import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import PageHeader from '@/components/PageHeader';
import BrandGearList from './brand-gears-list';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="Brand Gear">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Sport Brands</Breadcrumb.Item>
            <Breadcrumb.Item active>Brand Gears</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <BrandGearList />
    </Panel>
  );
};

export default Page;
